import React, { useEffect, useState } from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { CalendarPicker } from '@mui/x-date-pickers/CalendarPicker';
import { Typography } from '@mui/material';
import './style.scss';

export default function Calender({
  dateSelected, setDateSelect,
  availableDates,
}) {
  const handleDateChange = (date) => {
    setDateSelect(date)
  };

  const disableDates = (date) => {
    if(date.getDay() === 0) return true
    else if(date.getDay() === 6 ) return true
    
    //check condition if date exist in the 
    // check if availabledates have array value
    if(Object.keys(availableDates).length > 0 || availableDates != null){
      if(availableDates[dateInStringFormat(date)] === undefined) return true
    }
  }
  
  const addZeroIfSingle = (value) => {
    return value < 10 ? "0"+value : value
  }

  const dateInStringFormat = (value) => {
    return (value.getFullYear() + "-" + addZeroIfSingle(value.getMonth()+1) +"-"+ addZeroIfSingle(value.getDate()))
  }

  return (
    <>
      <Typography variant="h6" fontWeight="bold" sx={{ fontStyle: 'normal' }}>
        Select a Date & Time
      </Typography>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <CalendarPicker
            className={'agent_register_calendar'}
            date={dateSelected}
            // defaultCalendarMonth={new Date(dateInStringFormat(restrictedDate) + " 23:00")}
            onChange={handleDateChange}
            disablePast
            shouldDisableDate={disableDates}
            views={['day']}
        />
      </LocalizationProvider>
    </>
  );
}
